"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlySavingsCMS = void 0;
var MonthlySavingsCMS = /** @class */ (function () {
    function MonthlySavingsCMS() {
        this.moreLinesMoreSavings = 'More lines = more savings';
        this.goodNews = 'Good news! Your monthly plan price per line will go down with today\'s order.';
        this.tableHeaderForLine = 'LINE';
        this.tableHeaderForCurrentPrice = 'CURRENT PRICE';
        this.tableHeaderForNewPrice = 'NEW PRICE*';
        this.subTotals = 'Subtotals';
        this.monthlyPrices = 'Monthly prices shown are after any applicable discounts. Taxes and other fees extra.';
        this.pricingLegal = '* Pricing shown is effective when you activate all new and reserved lines. Previously reserved' +
            ' lines, if applicable, are not shown above but are factored into the price per line. The price' +
            ' on your bill for each active line will be higher until you activate all new and reserved lines.';
        this.monthlyPricesLabel = "Your monthly plan price per line will go down with today's order.\n     That's a total savings of {0} each month on your current lines!";
    }
    return MonthlySavingsCMS;
}());
exports.MonthlySavingsCMS = MonthlySavingsCMS;
//# sourceMappingURL=MonthlySavingsPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/MonthlySavingsPanel/MonthlySavingsPanel.cms.js
// module id = 1434
// module chunks = 8